module.exports = __webpack_public_path__ + "why8.png?c19e3ac4f3f48dea32889910b043e83c";